export default function tokenGenerator() {
    const randomString = () => (Math.random().toString(36).substr(2, 9));

    return randomString() + randomString();
}
